import { getAccessTokenId, getAdditionalGQLHeaders } from "./auth";
import { generatePersistedDeviceUUID } from "./deviceID";

const x_growsari_version_code = 362;
const x_growsari_version = "9.2.2";
const x_app_type = "web-store";
const x_growsari_app = "web-store";

const getHTTPHeaders: () => object = () => {
  return {
    "x-growsari-app": x_growsari_app,
    "x-growsari-version": x_growsari_version,
    "x-growsari-version-code": x_growsari_version_code,
    uuid: generateUUID(),
    authorization: `Bearer ${getAccessTokenId()}`,
    "x-app-type": x_app_type,
  };
};

const getHTTPHeadersForRestApi = () => {
  return {
    "x-growsari-app": x_growsari_app,
    "x-growsari-version": "8.5.0", // x_growsari_version,
    "x-growsari-version-code": 230, //x_growsari_version_code,
    authorization: `Bearer ${getAccessTokenId()}`,
    uuid: generateUUID(),
    "x-app-type": x_app_type,
  };
};

const getHTTPHeadersForCreditRestApi = () => {
  return {
    "x-growsari-app": x_growsari_app,
    authorization: `Bearer ${getAccessTokenId()}`,
    "x-app-type": x_app_type,
  };
};

const getHTTPHeadersForRESTSignUp = () => {
  return {
    "x-growsari-app": "store",
    authorization: `Bearer ${getAccessTokenId()}`,
    "x-app-type": x_app_type,
  };
};

const getMarketplaceGQLHTTPHeaders = async () => {
  const additionalData = await getAdditionalGQLHeaders();

  return {
    "x-growsari-app": x_growsari_app,
    "x-growsari-version": x_growsari_version,
    "x-growsari-version-code": x_growsari_version_code,
    uuid: generateUUID(),
    authorization: `Bearer ${getAccessTokenId()}`,
    "x-app-type": x_app_type,
    ...additionalData,
  };
};

const generateUUID = () => {
  const deviceUUID = generatePersistedDeviceUUID();

  return deviceUUID;
};

const getHeaderContentType = (type: "APPLICATION_JSON" | "FORM_URL_ENCODED" | "MULTIPART_FORM_DATA") => {
  switch (type) {
    case "APPLICATION_JSON": {
      return "application/json";
    }
    case "FORM_URL_ENCODED": {
      return "application/x-www-form-urlencoded";
    }
    case "MULTIPART_FORM_DATA": {
      return "multipart/form-data";
    }
    default: {
      return "application/json";
    }
  }
};

const getGrowCubeGQLHTTPHeaders = () => {
  return {
    authorization: `Bearer ${getAccessTokenId()}`,
  };
};

export {
  getHTTPHeaders,
  getHTTPHeadersForRestApi,
  getHTTPHeadersForCreditRestApi,
  getHTTPHeadersForRESTSignUp,
  getMarketplaceGQLHTTPHeaders,
  getHeaderContentType,
  getGrowCubeGQLHTTPHeaders,
};
